export default __webpack_public_path__ + "static/newsletter-placeholder-399fba5333c9078b89076f5127fa051e.jpg";